import { forEach } from 'lodash';

/**
 *  Before removing any functions or changing the functionality of this file,
 *  please check the use cases of this function.For example this is used in
 *  the matches component and the calendar components
 * @param data
 * @returns {*[]}
 */
const flattenDayEntries = (data) => {
  if (!data) return [];
  const output = [];

  forEach(data.fixtures, (fixtureData) => {
    const fixture = fixtureData;
    fixture.sortType = 'fixture';
    output.push(fixture);
  });

  forEach(data.clubEvents, (eventData) => {
    const event = eventData;
    event.sortType = 'event';
    output.push(event);
  });

  forEach(data.trainingSessions, (sessionData) => {
    const session = sessionData;
    session.sortType = 'training';
    output.push(session);
  });

  return output.sort((a, b) => {
    const aTime = a.sortType === 'fixture' ? a.dateTime : a.start;
    const bTime = b.sortType === 'fixture' ? b.dateTime : b.start;
    return new Date(aTime) - new Date(bTime);
  });
};

export default flattenDayEntries;
